import createSvgIcon from "../../utils/createSvgIcon";
/**
 * @ignore - internal component.
 */
export default createSvgIcon(() => <path d="M7 10l5 5 5-5z"/>, "ArrowDropDown");
